import { useLocation } from "react-router-dom";

import { Button } from "@/design-system/components/Button/Button";
import useAccountMetadata from "@/hooks/useAccountMetadata";

import { getPreviewProfile, getPreviewProfileLabel } from "./profiles";
import { disablePreviewMode, isPreviewModeEnabled } from "./runtime";
import { pathHasPreviewData } from "./supported-features";

const SCHEDULE_DEMO_URL =
  "https://www.freshpaint.io/contact-sales?utm_source=app&utm_medium=preview_mode_banner&utm_campaign=preview_mode#Book-a-Time";

export function PreviewBanner() {
  const { pathname } = useLocation();
  const accountMetadata = useAccountMetadata();
  if (accountMetadata?.config?.disableMasqueradeWarningBanner) return null;
  if (!isPreviewModeEnabled()) return null;
  if (!pathHasPreviewData(pathname)) return null;

  const profileLabel = getPreviewProfileLabel(getPreviewProfile());

  return (
    // Soft yellow, not status-warning: preview is promotional chrome that
    // pairs with the yellow-300 pill. status-warning is a darker yellow
    // (text/icon), which reads more like an alert than a preview banner.
    <div className="flex items-center justify-between gap-3 border-b border-yellow-200 bg-yellow-50 px-8 py-3">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <span className="shrink-0 rounded bg-yellow-300 px-2 py-1 text-xs leading-4 font-semibold text-blue-900">
          Preview
        </span>
        <p className="min-w-0 text-sm leading-6">
          <span className="text-textDefault font-medium">
            You&rsquo;re previewing with sample data.
          </span>{" "}
          <span className="font-normal text-gray-600">
            Profile:{" "}
            <span
              className="text-textDefault font-medium"
              data-testid="preview-profile-name"
            >
              {profileLabel}
            </span>
            . See how this would work for your team by scheduling a demo.
          </span>
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2.5">
        <Button variant="link" size="md" onClick={disablePreviewMode}>
          Exit preview
        </Button>
        <Button
          variant="outline"
          size="md"
          onClick={() =>
            window.open(SCHEDULE_DEMO_URL, "_blank", "noopener,noreferrer")
          }
        >
          Schedule a demo
        </Button>
      </div>
    </div>
  );
}
